import { EVENTS_APP_ID } from './app-definitions';
export var SERVER_BASE_URL = 'https://apps.wix.com/events-server';
export var getBillingUrl = function (msid, referral) {
    return "https://www.wix.com/store/plans?v=1&appDefId=" + EVENTS_APP_ID + "&siteGuid=" + msid + (referral ? "&referralAdditionalInfo=" + referral : '') + "#/";
};
//# sourceMappingURL=urls.js.map